import Navbar from '@features/legal/terms-and-conditions/navbar';
import {
  AcceptanceSection,
  AdditionalTermsSection,
  AllTransactionsArbitrationSection,
  ArbitrationSection,
  BuyerConditionTable,
  GeneralTermsSection,
  OffSiteVehicleSalesSection,
  OnlineSalesArbitrationSection,
  OtherLegacyServicesSection,
  OtherOnlineAuctionSection,
  PriceBoostingSection,
  TermsOfServiceIntro,
} from '@features/legal/terms-and-conditions/terms-sections';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

const TermsAndConditions = (): JSX.Element => {
  return (
    <Box sx={{ width: '100%' }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <TermsOfServiceIntro />
          </Grid>
          <Grid item xs={12} md={10} lg={8}>
            <GeneralTermsSection />
            <ArbitrationSection />
            <AllTransactionsArbitrationSection />
            <OnlineSalesArbitrationSection />
            <AdditionalTermsSection />
          </Grid>
        </Grid>
        <BuyerConditionTable />
        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md={10} lg={8}>
            <PriceBoostingSection />
            <OtherOnlineAuctionSection />
            <OffSiteVehicleSalesSection />
            <OtherLegacyServicesSection />
            <AcceptanceSection />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
